<template>
	<div>
		<!-- todo; this should be an upload field -->
		<v-text-field v-model="survey.image" label="Headline Image" display-hint hint="Include an image"></v-text-field>
		<v-text-field v-model="survey.logo" label="A client logo" display-hint hint="Overlayed on image"></v-text-field>
		<v-text-field v-model="survey.headlineText" label="Headline Text" display-hint hint="Text goes over the image"></v-text-field>
		<v-text-field v-model="survey.subheadingText" label="Subheading Text" display-hint hint="A second headline"></v-text-field>
		<h5 class="mt-4 ml-1">Blurb Text</h5>
		<vue-editor v-model="survey.blurb" label="Blurb Text"></vue-editor>
		<h5 class="mt-4 ml-1">Action Box Text</h5>
		<vue-editor v-model="survey.actionBox" label="Action Box Text" ></vue-editor>
	</div>
	
</template>


<script>
	import {VueEditor} from 'vue2-editor';
	export default {
		name: "EditScreenerFields.vue",
		props: {
			survey: {type: Object}
		},
		components: {
			VueEditor
		}
	}
</script>